(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const collectionLinks = document.querySelectorAll('.collection-sidebar__link');
    const collectionSections = document.querySelectorAll('.collection-section');
    
    // Function to calculate header height
    function getHeaderHeight() {
      const header = document.querySelector('header-menu, .header, [data-header], .shopify-section-group-header-group');
      if (header) {
        const rect = header.getBoundingClientRect();
        return rect.height;
      }
      // Different fallbacks for mobile and desktop
      return window.innerWidth < 750 ? 60 : 80; // mobile vs desktop fallback
    }
    
    // Function to scroll to element with header offset
    function scrollToElement(element) {
      const headerHeight = getHeaderHeight();
      const elementRect = element.getBoundingClientRect();
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const elementTop = elementRect.top + currentScrollTop;
      
      // Different buffer for mobile and desktop
      const isMobile = window.innerWidth < 750;
      const buffer = isMobile ? 30 : 60; // smaller buffer for mobile
      
      const scrollPosition = elementTop - headerHeight - buffer;
      
      window.scrollTo({
        top: Math.max(0, scrollPosition),
        behavior: 'smooth'
      });
    }
    
    // Function to close mobile drawer
    function closeMobileDrawer() {
      const mobileDrawer = document.querySelector('.menu-drawer-container[open]');
      if (mobileDrawer) {
        mobileDrawer.removeAttribute('open');
      }
      
      // Also close header drawer if exists
      const headerDrawer = document.querySelector('header-drawer .menu-drawer-container[open]');
      if (headerDrawer) {
        headerDrawer.removeAttribute('open');
      }
      
      // Remove menu-open class from body
      document.body.classList.remove('menu-open');
    }
    
    // Handle collection link clicks
    collectionLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Close mobile drawer
        closeMobileDrawer();
        
        // Remove active class from all links
        collectionLinks.forEach(l => l.classList.remove('active'));
        
        // Add active class to clicked link
        link.classList.add('active');
        
        // Smooth scroll to the collection section with header offset
        const targetId = link.getAttribute('href').substring(1);
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
          scrollToElement(targetSection);
        }
        
        // Update URL hash without triggering scroll
        history.replaceState(null, null, link.getAttribute('href'));
      });
    });
    
    // Handle initial hash from URL
    const url = new URL(window.location.href);
    if (url.hash && url.hash.startsWith('#collection-')) {
      const targetLink = document.querySelector(`a[href="${url.hash}"]`);
      const targetSection = document.getElementById(url.hash.slice(1));
      
      if (targetSection) {
        // Close mobile drawer if hash matches a collection
        closeMobileDrawer();
        
        // Remove active from all links
        collectionLinks.forEach(l => l.classList.remove('active'));
        
        // Activate target link
        if (targetLink) {
          targetLink.classList.add('active');
        }
        
        // Wait for page to fully load then scroll
        setTimeout(() => {
          scrollToElement(targetSection);
        }, 300);
      }
    }

    // Intersection Observer for auto-highlighting active collection while scrolling
    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          const correspondingLink = document.querySelector(`a[href="#${sectionId}"]`);
          
          if (correspondingLink) {
            // Remove active from all links
            collectionLinks.forEach(l => l.classList.remove('active'));
            // Add active to corresponding link
            correspondingLink.classList.add('active');
          }
        }
      });
    }, observerOptions);

    // Observe all collection sections
    collectionSections.forEach(section => {
      observer.observe(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["special-collection-list"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const collectionLinks = document.querySelectorAll('.collection-sidebar__link');
    const collectionSections = document.querySelectorAll('.collection-section');
    
    // Handle collection link clicks
    collectionLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all links
        collectionLinks.forEach(l => l.classList.remove('active'));
        
        // Add active class to clicked link
        link.classList.add('active');
        
        // Smooth scroll to the collection section
        const targetId = link.getAttribute('href').substring(1);
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
          targetSection.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
          });
        }
        
        // Update URL hash without triggering scroll
        history.replaceState(null, null, link.getAttribute('href'));
      });
    });
    
    // Handle initial hash from URL
    const url = new URL(window.location.href);
    if (url.hash) {
      const targetLink = document.querySelector(`a[href="${url.hash}"]`);
      const targetSection = document.getElementById(url.hash.slice(1));
      
      if (targetLink && targetSection) {
        // Remove active from all links
        collectionLinks.forEach(l => l.classList.remove('active'));
        
        // Activate target link
        targetLink.classList.add('active');
        
        setTimeout(() => {
          targetSection.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }

    // Intersection Observer for auto-highlighting active collection while scrolling
    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          const correspondingLink = document.querySelector(`a[href="#${sectionId}"]`);
          
          if (correspondingLink) {
            // Remove active from all links
            collectionLinks.forEach(l => l.classList.remove('active'));
            // Add active to corresponding link
            correspondingLink.classList.add('active');
          }
        }
      });
    }, observerOptions);

    // Observe all collection sections
    collectionSections.forEach(section => {
      observer.observe(section);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
